(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-spela/assets/system-selector/system-explanation.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-spela/assets/system-selector/system-explanation.js');
"use strict";


const _svs$components$tipse = svs.components.tipsen.engine.constants.systems,
  SYSTEM_RSYS = _svs$components$tipse.SYSTEM_RSYS,
  SYSTEM_USYS = _svs$components$tipse.SYSTEM_USYS,
  SYSTEM_REDUCERA_FRITT = _svs$components$tipse.SYSTEM_REDUCERA_FRITT;
const getSystemFromNumber = svs.components.sport.systems.getSystemFromNumber;
const Icon = svs.ui.ReactIcon;
const TipsenLink = svs.components.tipsen.tipsen_link.TipsenLink;
const TipsenModuleGameUrl = svs.components.sport.tipsenShared.TipsenModuleGameUrl;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM;
const SystemExplanation = _ref => {
  var _system$numFullHedges, _system$numHalfHedges, _system$rows$length, _system$rows, _system$guaranty;
  let selectedItem = _ref.selectedItem,
    selectedSystem = _ref.selectedSystem;
  const isExtraSmall = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const isReduceFree = selectedItem === SYSTEM_REDUCERA_FRITT;
  if (isReduceFree) {
    return null;
  }
  const system = getSystemFromNumber(selectedSystem);
  return React.createElement("div", {
    className: "tipsen-system-explanation ".concat(isExtraSmall ? 'tipsen-system-explanation--small' : '')
  }, React.createElement("div", {
    className: "tipsen-system-explanation--item tipsen-system-explanation--full-hedge"
  }, React.createElement(Icon, {
    icon: "hedge-full",
    size: "0"
  }), React.createElement("span", {
    className: "f-left"
  }, "Helgarderingar:"), React.createElement("span", {
    className: "f-550 ".concat(!isExtraSmall ? 'margin-right-2' : '')
  }, (_system$numFullHedges = system === null || system === void 0 ? void 0 : system.numFullHedges) !== null && _system$numFullHedges !== void 0 ? _system$numFullHedges : '-')), React.createElement("div", {
    className: "tipsen-system-explanation--item tipsen-system-explanation--half-hedge"
  }, React.createElement(Icon, {
    icon: "hedge-half",
    size: "0"
  }), React.createElement("span", {
    className: "f-left"
  }, "Halvgarderingar:"), React.createElement("span", {
    className: "f-550 ".concat(!isExtraSmall ? 'margin-right-2' : '')
  }, (_system$numHalfHedges = system === null || system === void 0 ? void 0 : system.numHalfHedges) !== null && _system$numHalfHedges !== void 0 ? _system$numHalfHedges : '-')), React.createElement("div", {
    className: "tipsen-system-explanation--item tipsen-system-explanation--price"
  }, React.createElement(Icon, {
    icon: "rows",
    size: "0"
  }), React.createElement("span", {
    className: "f-left"
  }, "Antal rader och pris:"), React.createElement("span", {
    className: "f-550"
  }, (_system$rows$length = system === null || system === void 0 || (_system$rows = system.rows) === null || _system$rows === void 0 ? void 0 : _system$rows.length) !== null && _system$rows$length !== void 0 ? _system$rows$length : '-')), selectedItem === SYSTEM_RSYS && React.createElement("div", {
    className: "tipsen-system-explanation--item tipsen-system-explanation--guaranty"
  }, React.createElement(Icon, {
    icon: "checkmark",
    size: "0"
  }), React.createElement("span", {
    className: "f-left"
  }, "Garanterat antal r\xE4tt n\xE4r alla tecken \xE4r r\xE4tt tippade:"), React.createElement("span", {
    className: "f-550"
  }, (_system$guaranty = system === null || system === void 0 ? void 0 : system.guaranty) !== null && _system$guaranty !== void 0 ? _system$guaranty : '-')), selectedItem === SYSTEM_USYS && React.createElement("div", {
    className: "tipsen-system-explanation--guaranty"
  }, React.createElement("span", {
    className: "f-left"
  }, "U-systemet garanterar 13 r\xE4tt, f\xF6rutsatt att alla U-tecken samt spikade matcher(endast ett tecken valt) \xE4r r\xE4tt tippade.")), React.createElement(TipsenLink, {
    "aria-label": "L\xE4s mer om systemspel",
    className: "f-left",
    to: "/".concat(TipsenModuleGameUrl.SYSTEM, "/spelguide?flik=systemspel")
  }, "L\xE4s mer om", selectedItem === SYSTEM_RSYS ? ' R-system' : ' U-system', "."));
};
setGlobal('svs.components.tipsen.routePlaySpela.systemSelector.SystemExplanation', SystemExplanation);

 })(window);